import { AlertColor, Button, CircularProgress, Modal, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import React, { useImperativeHandle } from 'react';
import { globalTheme } from '../../../common/theme';
import { SnackBarMessage, SnackBarMessageProps } from '../../component/SnackBarMessage';
import { useAppSelector } from '../../../common/hooks';
import { RootState } from '../../../common/Store';
import Title from '../../component/Title';
import moment from 'moment';
import { PurchaseOrderRankFilter } from '../../../models/classes/PurchaseOrderFilter';
import { FormatDateForFileName } from '../../../common/CommonFunctions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        margin: {
            margin: theme.spacing(1),
        },
        modalPaper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
        control: {
            marginBottom: theme.spacing(1)
        }
    }),

);

export interface PurchaseOrderRankingViewerHandle {
    Initialise: (region: string, createdFrom: Date, createdTo: Date, reportType: number) => void,
}

export interface PurchaseOrderRankingViewerProps {
    onClose: Function;
}
  
export const PurchaseOrderRankingViewer = React.forwardRef((props: PurchaseOrderRankingViewerProps, ref: React.Ref<PurchaseOrderRankingViewerHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };
    const isDebug = useAppSelector((state: RootState) => state.menuToggle.debugMode);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState<any>();
    const [filter, setFilter] = React.useState<PurchaseOrderRankFilter>();

    //Dialogs and snacks
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }


    const [viewerUrl, setViewerUrl] = React.useState<string>("");

    useImperativeHandle(ref, () => ({
        Initialise(region: string, createdFrom: Date, createdTo: Date, reportType: number) {
            setOpen(true);
            setLoading(true);

            let f = new PurchaseOrderRankFilter({
                From: moment(createdFrom).format(),
                To: moment(createdTo).format(),
                Region: region,
                Type: reportType,
                Reader: ""
            });

            setFilter(f);
    
            GenerateReport(f);
        }

    }));

    function Export(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        axios.post(`Api/V1/PurchaseOrder/Rank/Export`, filter, {
            headers: {
                'Content-Encoding': 'gzip'
            },
            responseType: 'blob'
        })
            .then((result) => {
                const file = new Blob([result.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" });
  
                const url = window.URL.createObjectURL(file);
  
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.href = url;
                link.download = "PORank" + filter?.Region + FormatDateForFileName(filter?.From) + "-" + FormatDateForFileName(filter?.To) + ".tsv";
                link.click();
  
                setLoading(false);
            },
                (error) => {
                    console.log(error);
                    setLoading(false);
                    showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                }
            )
    }
  
    function CloseModal() {
        setOpen(false);
        props.onClose();
    }

    function GenerateReport(f: PurchaseOrderRankFilter) {
        axios.post('Api/V1/PurchaseOrder/Rank', f, {
            headers: {
                'Content-Encoding': 'gzip'
            },
            responseType: 'blob'
        })
            .then((result) => {
                const file = new Blob([result.data], { type: "application/pdf" });

                const url = window.URL.createObjectURL(file);

                setViewerUrl(url);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
                showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
        );
    }

    return (
        <div>
            <Modal
                open={open}
             >
                <div className={style.ModalMain}>

                    {!loading ? (
                        <div style={{ height: '100%' }}>
                            <Title pageTitle={(filter?.Type == 0 ? "Customer" : "End User") + " Rank Report (" + filter?.Region + "-" + FormatDateForFileName(filter?.From) + " - " + FormatDateForFileName(filter?.To) + ")"} />

                            <div className={style.ModalHeading}>
                                <Typography variant="h4">{(filter?.Type == 0 ? "Customer" : "End User") + " Rank Report (" + filter?.Region + "-" + FormatDateForFileName(filter?.From) + " - " + FormatDateForFileName(filter?.To) + ")"}</Typography>
                            </div>

                            <div className={style.ModalContent} style={{height: '75vh'}}>
                                <iframe src={viewerUrl} width="100%" height="100%" style={{overflow: 'auto'}}>
                                </iframe>
                            </div>

                            <div className={style.ModalFooter}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={style.margin}
                                    onClick={(e) => Export(e)}>Export</Button>
                                <Button
                                    variant="contained"
                                    className={style.margin}
                                    onClick={(e) => CloseModal()}>Close</Button>
                            </div>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <CircularProgress color="primary" />
                        </div>
                    )}



                </div>
            </Modal>

            <SnackBarMessage {...snackSettings} />

        </div >
    );
});